"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMinerAddress = exports.findQuarryAddress = exports.findRewarderAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("../../constants");
const findRewarderAddress = (base, programID = constants_1.SUNNY_ADDRESSES.Mine) => __awaiter(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([Buffer.from(anchor_1.utils.bytes.utf8.encode("Rewarder")), base.toBytes()], programID);
});
exports.findRewarderAddress = findRewarderAddress;
const findQuarryAddress = (rewarder, tokenMint, programID = constants_1.SUNNY_ADDRESSES.Mine) => __awaiter(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        Buffer.from(anchor_1.utils.bytes.utf8.encode("Quarry")),
        rewarder.toBytes(),
        tokenMint.toBytes(),
    ], programID);
});
exports.findQuarryAddress = findQuarryAddress;
const findMinerAddress = (quarry, authority, programID = constants_1.SUNNY_ADDRESSES.Mine) => __awaiter(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        Buffer.from(anchor_1.utils.bytes.utf8.encode("Miner")),
        quarry.toBytes(),
        authority.toBytes(),
    ], programID);
});
exports.findMinerAddress = findMinerAddress;
//# sourceMappingURL=pda.js.map